import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_ROUTES } from "../services/apiRoutes";
import axiosInstance from "../utils/axiosInstance";

const initialState = {
    loading: false,
    popupData: {},
};

export const getPopupData = createAsyncThunk(
    "admin/getPopupData",
    async (thunkAPI) => {
        try {
            const response = await axiosInstance.get(API_ROUTES.GET_POPUP_DATA);

            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response); // Reject with an error message
        }
    }
);

export const sendPopupData = createAsyncThunk(
    "admin/sendPopupData",
    async (data, thunkAPI) => {
        try {
            const response = await axiosInstance.put(API_ROUTES.PUT_POPUP_DATA, data);

            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response); // Reject with an error message
        }
    }
);
export const PopupSlice = createSlice({
    name: "PopupSlice",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getPopupData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getPopupData.fulfilled, (state, action) => {
                state.loading = false;
                state.popupData = action.payload.data.data;
            })
            .addCase(getPopupData.rejected, (state, action) => {
                state.loading = false;
            });

        builder
            .addCase(sendPopupData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(sendPopupData.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendPopupData.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

// export const { loginUser, logoutUser } = userSlice.actions;
export default PopupSlice.reducer;
